import React, { useContext, useEffect, useMemo, useState } from 'react';
import { UserDataContext } from '../../../../shared/context/userDataContext';
import { getToken } from '../../../../shared/const/token.helper';
import TrainingRequired from '../../get-quote/training-required/trainingRequired';

const WelcomeGetQuote = () => {
  const {
    selectedBrand,
    userData,
    selectedBusinessUnit,
    dataCenter,
    userRoles,
    sessionContext,
    usedPaymentMethod,
  } = useContext(UserDataContext);
  const [iframeUrl, setIframeUrl] = useState();
  const token = getToken();

  useEffect(() => {
    // Build base URL first
    let url = `${dataCenter.widgetUrl}?brand=${selectedBusinessUnit?.brand}&token=${token}&sessionToken=${sessionContext}&redirectUrl=/`;

    // Add payment method if available
    if (usedPaymentMethod) {
      url += `&paymentMethod=${usedPaymentMethod}`;
    }

    setIframeUrl(url);
  }, [
    sessionContext,
    usedPaymentMethod,
    dataCenter.widgetUrl,
    selectedBusinessUnit,
    token,
  ]);

  const shouldSeeWidget = useMemo(
    () => userRoles.sales && !userData.quotesLocked,
    [userRoles, selectedBrand],
  );

  const shouldSeeError = useMemo(
    () => userData?.lmsTrainingRequired && !userData?.lmsTrainingCompleted,
    [selectedBrand],
  );

  return (
    <>
      {dataCenter.widgetUrl && (
        <>
          {shouldSeeWidget ? (
            <div
              style={{
                minHeight: '50px',
                marginBottom: '1rem',
                borderRadius: '.75rem',
                overflow: 'hidden',
                backgroundColor: 'transparent',
              }}
              className="welcome-get-quote"
            >
              <iframe
                id="bookingWidget"
                style={{ backgroundColor: 'transparent' }}
                src={iframeUrl}
                allow="clipboard-write"
              ></iframe>
            </div>
          ) : (
            shouldSeeError && <TrainingRequired />
          )}
        </>
      )}
    </>
  );
};

export default WelcomeGetQuote;
